export {
  HeroWithRichText,
  type IHeroWithRichTextProps,
} from './hero-with-rich-text'
